export const dateToString = (date: Date, withTime: boolean, time?: string) => {
  let result = `${date.getDate()}. ${date.getMonth() + 1}. ${date.getFullYear()}`;

  result += withTime ? ` • ${time}` : '';

  return result;
};
